import axios from 'axios';
import { getToken, setToken, removeToken } from '@/functions/token';
import { showPopup } from '@/functions/popup';

const API_URL = process.env.VUE_APP_API_URL;
const PLATFORM = window?.WebApp?.initDataUnsafe?.user?.id
  ? 'max'
  : window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
  ? 'telegram'
  : null;

export function auth(phone, chat_instance, callback) {
  const path = PLATFORM === 'max' ? 'auth/max' : 'auth';
  axios
    .post(
      `${API_URL}${path}`,
      { phone: phone, chat_instance: chat_instance },
      {
        headers: {
          'X-Miniapp-Source': PLATFORM,
        },
      },
    )
    .then((response) => {
      if (response?.data?.ok && response?.data?.token) {
        setToken(response.data.token, () => {
          callback(response.data.token);
        });
      } else {
        callback(false);
      }
    })
    .catch((error) => {
      console.log(error);
      showPopup('Что-то пошло не так. Попробуйте позже.', '', () => {
        callback(false);
      });
    });
}

export function reAuth(chat_instance, callback) {
  const path = PLATFORM === 'max' ? 'auth/max' : 'auth';
  axios
    .post(
      `${API_URL}${path}`,
      { chat_instance: chat_instance },
      {
        headers: {
          'X-Miniapp-Source': PLATFORM,
        },
      },
    )
    .then((response) => {
      if (response?.data?.ok && response?.data?.token) {
        setToken(response.data.token, () => {
          callback(response.data.token);
        });
      } else {
        callback(false);
      }
    })
    .catch((error) => {
      console.log(error);
      callback(false);
    });
}

export function getProfile(callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .get(`${API_URL}profile`, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getFavorites(page, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
      params: {
        page: page,
      },
    };
    axios
      .get(`${API_URL}posts/liked`, config)
      .then((response) => {
        callback(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getCategories(page, categoryId = null, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
      params: {
        page: page,
      },
    };
    if (categoryId) {
      config.params.filter = {
        ...config.params.filter,
        category_id: categoryId,
      };
    }
    axios
      .get(`${API_URL}categories`, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getCategory(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .get(`${API_URL}categories/${id}`, config)
      .then((response) => {
        callback(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getPosts(page, filter = {}, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
      params: {
        page: page,
        filter: {},
      },
    };
    if (filter.visible_in) {
      config.params.filter = {
        ...config.params.filter,
        visible_in: filter.visible_in,
      };
    }
    if (filter.search) {
      config.params.filter = { ...config.params.filter, search: filter.search };
    }
    if (
      typeof filter.category_id == 'object' &&
      filter.category_id.length > 0
    ) {
      config.params.filter = {
        ...config.params.filter,
        category_id: filter.category_id.reduce((f, s) => `${f},${s}`),
      };
    }
    if (filter.category_id && typeof filter.category_id == 'number') {
      config.params.filter = {
        ...config.params.filter,
        category_id: filter.category_id,
      };
    }
    if (typeof filter.author_id == 'object' && filter.author_id.length > 0) {
      config.params.filter = {
        ...config.params.filter,
        author_id: filter.author_id.reduce((f, s) => `${f},${s}`),
      };
    }
    if (filter.author_id && typeof filter.author_id == 'number') {
      config.params.filter.author_id = filter.author_id;
    }
    axios
      .get(`${API_URL}posts`, config)
      .then((response) => {
        callback(response?.data?.data, response?.data?.meta);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getArticle(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .get(`${API_URL}posts/${id}`, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getHistorys(callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .get(`${API_URL}feed`, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function watchHistory(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .post(`${API_URL}stories/${id}/view`, {}, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function like(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .post(`${API_URL}posts/${id}/like`, { post: id }, config)
      .then(() => {
        callback(true);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function unlike(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .delete(`${API_URL}posts/${id}/unlike`, config, {
        post: id,
      })
      .then(() => {
        callback(true);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function callbackSend(data, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .post(`${API_URL}feedback`, data, config)
      .then((response) => {
        callback({ ok: true, data: response.data });
      })
      .catch((error) => {
        console.log(error);
        callback({ ok: false, error: error });
      });
  });
}

export function getCategoriesFilter(callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
      params: {
        page: 1,
        itemsPerPage: -1,
      },
    };
    axios
      .get(`${API_URL}categories`, config)
      .then((response) => {
        callback(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}
export function videoView(postId, fileId, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .post(`${API_URL}posts/${postId}/files/${fileId}/video-view`, {}, config)
      .then((response) => {
        callback(response?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getAuthor(id, callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
    };
    axios
      .get(`${API_URL}authors/${id}`, config)
      .then((response) => {
        callback(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}

export function getAuthorsFilter(callback) {
  getToken((token) => {
    if (token === null || token === 'null') {
      callback(false);
      reAuth();
      return;
    }
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        'X-Miniapp-Source': PLATFORM,
      },
      params: {
        page: 1,
        itemsPerPage: -1,
      },
    };
    axios
      .get(`${API_URL}authors`, config)
      .then((response) => {
        callback(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          removeToken();
        }
        callback(false);
      });
  });
}
